import { useNavigate } from "react-router-dom";

function SquaredButtons4Controller2() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="p-4">
      <div className="flex flex-col space-y-4">
        <div className="flex space-x-4">
          <button
            className="w-full py-4 text-white bg-purple-600 rounded-none hover:bg-purple-700"
            onClick={() => handleNavigation("#")}
          >
            1
          </button>
          <button
            className="w-full py-4 text-white bg-orange-600 rounded-none hover:bg-orange-700"
            onClick={() => handleNavigation("#")}
          >
            2
          </button>
        </div>
        <div className="flex flex-col space-y-4">
          <button
            className="w-full py-4 text-white bg-teal-600 rounded-none hover:bg-teal-700"
            onClick={() => handleNavigation("#")}
          >
            3
          </button>
          <button
            className="w-full py-4 text-white bg-pink-600 rounded-none hover:bg-pink-700"
            onClick={() => handleNavigation("#")}
          >
            4
          </button>
        </div>
      </div>
    </div>
  );
}

export default SquaredButtons4Controller2;
